import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "inline-block ml-1"
}

import { BaseIcon } from '@/lib/components/Icon';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import NumberBadge from '@/lib/components/Badge/NumberBadge.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavLink',
  props: {
  to: {
    type: [String, Object],
    default: null
  },
  icon: {
    type: String,
    default: null
  },
  badgeEnabled: {
    type: Boolean,
    default: false
  },
  badgeNumber: {
    type: [String, Number],
    default: 0
  }
},
  setup(__props) {
const props = __props;

const showBadge = computed(() => props.badgeEnabled && Number(props.badgeNumber) > 0);
const currentRoute = useRoute();
const isRouteActive = (path: string) => currentRoute?.path.includes(path);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.to ? 'router-link' : 'a'), { to: __props.to }, {
    default: _withCtx(({ route }) => [
      _createElementVNode("div", {
        class: _normalizeClass([[
        isRouteActive(route.path)
          ? 'text-dark-500 border-primary-500'
          : 'text-gray-400 border-transparent group-hover:text-gray-900 group-hover:border-gray-400 group-focus:text-gray-900 group-focus:border-gray-400'
      ], "flex items-center font-semibold border-b-2 mx-5 focus:outline-none group h-full"])
      }, [
        (__props.icon)
          ? (_openBlock(), _createBlock(_unref(BaseIcon), {
              key: 0,
              name: __props.icon,
              class: "mr-2"
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default"),
        (showBadge.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(NumberBadge, {
                "badge-number": __props.badgeNumber,
                color: "primary"
              }, null, 8, ["badge-number"])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 3
  }, 8, ["to"]))
}
}

})